export enum Municipality {
  BeiJin = '110000',
  TianJin = '120000',
  ShangHai = '310000',
  ChongQin = '500000'
}

export const municipalityList = [
  Municipality.BeiJin,
  Municipality.ShangHai,
  Municipality.TianJin,
  Municipality.ChongQin
]

export interface City {
  cityId: string | number
  cityName: string
}
export const defaultCity: City = {
  cityId: '320100',
  cityName: '南京'
}
